// extracted by mini-css-extract-plugin
export default {"msgM":"d890dbd1a4"};